/* ===========================================================================
   Brick Street — theme scripts
   ---------------------------------------------------------------------------
   Vanilla, no dependencies, no build step. Everything here is progressive:
   the variant picker is a real radio group inside a real form, so the product
   page still adds to cart with JS switched off. This only upgrades it.
   =========================================================================== */
(function () {
  "use strict";

  /* --- header menu ------------------------------------------------------ */
  var menuBtn = document.getElementById("menu-toggle");
  var menuPanel = document.getElementById("menu-panel");
  if (menuBtn && menuPanel) {
    menuBtn.addEventListener("click", function () {
      var open = menuBtn.getAttribute("aria-expanded") === "true";
      menuBtn.setAttribute("aria-expanded", String(!open));
      menuPanel.hidden = open;
    });
    menuPanel.addEventListener("click", function (ev) {
      if (!ev.target.closest("a")) return;
      menuBtn.setAttribute("aria-expanded", "false");
      menuPanel.hidden = true;
    });
    document.addEventListener("keydown", function (ev) {
      if (ev.key !== "Escape" || menuPanel.hidden) return;
      menuBtn.setAttribute("aria-expanded", "false");
      menuPanel.hidden = true;
      menuBtn.focus();
    });
  }

  /* --- announcement strip ----------------------------------------------- */
  /* CSS runs the animation. This only decides whether it starts and remembers
     the answer. Reduce Motion sets the initial state rather than vetoing the
     feature, and is watched for changes because the value can settle after
     this script runs. An explicit press ends the tracking. */
  (function () {
    var KEY = "bs-ticker";
    var bar = document.getElementById("announce");
    var btn = document.getElementById("ticker-toggle");
    if (!bar || !btn) return;

    var glyph = btn.querySelector("[data-glyph]");
    var label = btn.querySelector("[data-label]");
    var stored = null;
    try {
      stored = localStorage.getItem(KEY);
    } catch (e) {}

    var calm = window.matchMedia("(prefers-reduced-motion: reduce)");
    var playing = stored ? stored === "playing" : !calm.matches;

    function apply() {
      bar.setAttribute("data-ticker", playing ? "playing" : "paused");
      btn.setAttribute("aria-pressed", String(!playing));
      if (glyph) glyph.textContent = playing ? "❚❚" : "▶";
      var text = playing ? "Pause the announcements" : "Play the announcements";
      if (label) label.textContent = text;
      btn.title = text;
    }

    btn.addEventListener("click", function () {
      playing = !playing;
      try {
        localStorage.setItem(KEY, playing ? "playing" : "paused");
      } catch (e) {}
      apply();
    });

    if (calm.addEventListener) {
      calm.addEventListener("change", function (ev) {
        if (stored) return;
        playing = !ev.matches;
        apply();
      });
    }

    apply();
  })();

  /* --- product card swatches -------------------------------------------- */
  /* Clicking a colourway swaps the card image to that variant's photo and
     repoints the card's links at the matching variant. */
  document.querySelectorAll("[data-card]").forEach(function (card) {
    var swatches = card.querySelectorAll("[data-swatch]");
    if (!swatches.length) return;
    var img = card.querySelector("[data-card-img]");
    var links = card.querySelectorAll("[data-card-link]");

    swatches.forEach(function (btn) {
      btn.addEventListener("click", function (ev) {
        ev.preventDefault();
        if (img && btn.dataset.image) {
          img.src = btn.dataset.image;
          if (btn.dataset.imageAlt) img.alt = btn.dataset.imageAlt;
          img.removeAttribute("srcset");
        }
        if (btn.dataset.url) {
          links.forEach(function (a) {
            a.href = btn.dataset.url;
          });
        }
        swatches.forEach(function (b) {
          b.setAttribute("aria-pressed", String(b === btn));
        });
      });
    });
  });

  /* --- product page ------------------------------------------------------ */
  document.querySelectorAll("[data-product-form]").forEach(function (root) {
    var dataEl = root.querySelector("[data-variants]");
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var idInput = root.querySelector("[data-variant-id]");
    var addBtn = root.querySelector("[data-add]");
    var priceEl = root.querySelector("[data-price]");
    var mainImg = root.querySelector("[data-main-img]");
    var inputs = root.querySelectorAll("[data-option-input]");
    var money = root.dataset.moneyFormat || "${{amount}}";

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      // Match Shopify's placeholder styles well enough for the common cases.
      var parts = amount.split(".");
      var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      if (/amount_no_decimals/.test(money)) {
        return money.replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas);
      }
      return money.replace(/\{\{\s*amount\s*\}\}/, withCommas + "." + parts[1]);
    }

    function selected() {
      var chosen = [];
      inputs.forEach(function (input) {
        if (input.checked) chosen[Number(input.dataset.optionIndex)] = input.value;
      });
      return chosen;
    }

    function match(chosen) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return chosen[i] === undefined || opt === chosen[i];
        });
      });
    }

    /* Grey out option values that cannot be reached from the current
       selection, so a shopper never picks a combination that does not exist. */
    function refreshAvailability(chosen) {
      inputs.forEach(function (input) {
        var i = Number(input.dataset.optionIndex);
        var probe = chosen.slice();
        probe[i] = input.value;
        var found = variants.filter(function (v) {
          return v.options.every(function (opt, n) {
            return probe[n] === undefined || opt === probe[n];
          });
        });
        var reachable = found.some(function (v) {
          return v.available;
        });
        input.disabled = found.length > 0 && !reachable;
      });
    }

    function update() {
      var chosen = selected();
      var variant = match(chosen);
      refreshAvailability(chosen);

      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.unavailable || "Unavailable";
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl && typeof variant.price === "number") {
        priceEl.textContent = formatMoney(variant.price);
      }
      if (mainImg && variant.image) {
        mainImg.src = variant.image;
        mainImg.removeAttribute("srcset");
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? addBtn.dataset.addLabel || "Add to bag"
          : addBtn.dataset.soldOut || "Sold out";
      }

      // Keep the URL shareable without adding a history entry per click.
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        history.replaceState({}, "", url);
      }
    }

    // Keep the "Size: Large" readout beside each option name in step.
    function refreshLabels() {
      inputs.forEach(function (input) {
        if (!input.checked) return;
        var out = root.querySelector(
          '[data-option-display="' + input.dataset.optionIndex + '"]'
        );
        if (out) out.textContent = input.value;
      });
    }

    inputs.forEach(function (input) {
      input.addEventListener("change", function () {
        refreshLabels();
        update();
      });
    });
    refreshLabels();
    update();

    /* thumbnails */
    root.querySelectorAll("[data-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (mainImg) {
          mainImg.src = thumb.dataset.full;
          mainImg.removeAttribute("srcset");
        }
        root.querySelectorAll("[data-thumb]").forEach(function (t) {
          t.setAttribute("aria-pressed", String(t === thumb));
        });
      });
    });

    /* quantity stepper */
    var qty = root.querySelector("[data-qty]");
    if (qty) {
      root.querySelectorAll("[data-qty-step]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var next = parseInt(qty.value, 10) + parseInt(btn.dataset.qtyStep, 10);
          qty.value = String(Math.max(1, isNaN(next) ? 1 : next));
        });
      });
    }
  });
})();
